export const buildBoxesURLSearchParams = ({
  cursor,
  filter,
  order,
  limit,
}: {
  cursor?: string;
  filter?: string;
  order?: string;
  limit?: number;
}) => {
  const params = new URLSearchParams();

  if (cursor) {
    params.set('cursor', cursor);
  }

  if (filter) {
    params.set('filter', filter);
  }

  if (order) {
    params.set('order', order);
  }

  if (limit) {
    params.set('limit', String(limit));
  }

  return params.toString() ? `?${params.toString()}` : '';
};
